<div class="flex flex-col justify-between h-full p-10 {{extraClass()}}">
  <div class="max-w-[25rem]">
    <div class="flex gap-4 items-center mb-5">
      <icon [name]="iconName()" [size]="'1.875rem'" class="shrink-0" />
      <h4>{{ title() }}</h4>
    </div>
    <p>{{text()}}</p>
  </div>
  <app-button
    [text]="buttonText()"
    [variant]="buttonVariant()"
    [size]="'sm'"
    [icon]="'arrow-right'"
    (buttonClick)="buttonClick.emit()"
    class="mt-3 w-fit"
  />
</div>
